export default __webpack_public_path__ + "static/chilld-8300b2b496b49972ace297811ee4882f.mp4";